import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { getNoPhotoUrl } from "@/lib/upload-logo";

interface ImageWithFallbackProps {
  src?: string | null;
  alt: string;
  className?: string;
  containerClassName?: string;
  onClick?: () => void;
}

export function ImageWithFallback({
  src,
  alt,
  className = "w-full h-full object-cover",
  containerClassName = "w-full h-full bg-muted",
  onClick,
}: ImageWithFallbackProps) {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Use no-photo image if src is empty or falsy
  const imageSrc = src && src.trim() ? src : getNoPhotoUrl();
  const showFallback = imageError || !src;

  return (
    <div className={containerClassName} onClick={onClick}>
      {!showFallback ? (
        <img
          src={imageSrc}
          alt={alt}
          className={className}
          onError={() => setImageError(true)}
          onLoad={() => setIsLoading(false)}
          style={isLoading ? { opacity: 0 } : { opacity: 1, transition: "opacity 0.3s" }}
        />
      ) : null}

      {showFallback && (
        <div className="flex items-center justify-center w-full h-full bg-muted">
          <div className="flex flex-col items-center gap-2 text-muted-foreground">
            <ImageIcon className="w-8 h-8" />
            <span className="text-xs font-medium">Sem foto</span>
          </div>
        </div>
      )}
    </div>
  );
}
